module.exports = __webpack_public_path__ + "img/balkon04.3d78acd0.webp";